<template>
  <div>
    menu
  </div>
</template>
<script>
export default {
  name: "volcan-menu",
  props: ["menu", "seo"],
  data: function() {
    return {
      doc: null
    };
  },
  beforeMount() {
    // if (!this.imageSync && this.seo.ogImage) {
    //   this.doc = { path: this.seo.ogImage, name: '' }
    // }
  },
  mounted: function() {},
  //   watch: {
  //     doc() {
  //       if (this.doc) {
  //         this.seo.ogImage = this.doc.path
  //       } else {
  //         this.seo.ogImage = ''
  //       }
  //     }
  //   },
  methods: {},
  computed: {}
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// components/Menu/index.vue